module.exports = __webpack_public_path__ + "assets/img/c2eec37793ce9c3479c2214d8d944a52.png";